import { Stack } from "@mui/material";
import { CheckGreen } from "src/assets";
import { ROUTES } from "src/consts/routes";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Text from "src/components/Displays/Text";
import PrimaryButton from "src/components/Shared/PrimaryButton";

const AccessSuccess = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleSubmit = () => {
    navigate(ROUTES.YOUR_NAME);
  };

  return (
    <Stack gap={10}>
      <Stack alignItems={"start"}>
        <CheckGreen />
      </Stack>

      <Text
        text={t("page.selfOnboardingSuccess.pageTitle")}
        sx={(theme) => ({
          fontWeight: 500,
          fontSize: "32px",
          lineHeight: "40px",
          fontFamily: "officina",
          color: theme.palette.mainFont.primary,
        })}
      />

      <Text
        text={t("page.selfOnboardingSuccess.pageSubTitle")}
        sx={(theme) => ({
          fontSize: "14px",
          fontWeight: "400",
          lineHeight: "20px",
          fontFamily: "Inter",
          color: theme.palette.mainFont.primary,
        })}
      />

      <PrimaryButton
        onClick={handleSubmit}
        text={t("page.selfOnboardingSuccess.nextButton")}
        sx={(theme) => ({
          fontSize: "14px",
          lineHeight: "20px",
          maxWidth: { sm: "320px" },
          color: theme.palette.mainFont.primary,
        })}
      />
    </Stack>
  );
};

export default AccessSuccess;
